import { Helpers } from '../../helpers';
import { IArtificialLiftType } from '../../interfaces/iartificial-lift-type';
import { Pipeline } from '../pipeline';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ScenarioWell } from '../scenario-well';
import { TankBattery } from '../tank-battery';

export class ArtificialLiftTypeBase {
  ArtificialLiftTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pipelines_ArtificialLiftType?: Array<Pipeline> | null;
  ProjectCompletionsParameters_ArtificialLiftType?: Array<ProjectCompletionsParameter> | null;
  ScenarioWells_ArtificialLiftType?: Array<ScenarioWell> | null;
  TankBatteries_ArtificialLiftType?: Array<TankBattery> | null;
  ScenarioWells_PreferredArtificialLiftType?: Array<ScenarioWell> | null;

  constructor(item?: IArtificialLiftType) {
    if (item) {

      this.ArtificialLiftTypeId = item.ArtificialLiftTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pipelines_ArtificialLiftType = Helpers.createClassArray(Pipeline, item.Pipelines_ArtificialLiftType);
      this.ProjectCompletionsParameters_ArtificialLiftType = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_ArtificialLiftType);
      this.ScenarioWells_ArtificialLiftType = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_ArtificialLiftType);
      this.TankBatteries_ArtificialLiftType = Helpers.createClassArray(TankBattery, item.TankBatteries_ArtificialLiftType);
      this.ScenarioWells_PreferredArtificialLiftType = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_PreferredArtificialLiftType);
    }
  }
}